import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="submission-batch-selection"
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "submitButton", "count", "noun"]
  static values = { singularNoun: String, pluralNoun: String }

  connect() {
    this.update()
  }

  toggleAll(event) {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = event.currentTarget.checked
    })

    this.update()
  }

  update() {
    const selectedCount = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
    const allSelected = selectedCount === this.checkboxTargets.length && this.checkboxTargets.length > 0

    this.submitButtonTarget.disabled = selectedCount === 0
    this.countTarget.textContent = selectedCount
    this.nounTarget.textContent = selectedCount === 1 ? this.singularNounValue : this.pluralNounValue

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = allSelected
      this.selectAllTarget.indeterminate = selectedCount > 0 && !allSelected
    }
  }
}
